import { CreateBrandedEnum, type ZodInfer } from '@mntn-dev/utility-types'

import {
  type PartnerProgramKind,
  PartnerProgramKindSchema,
} from './partner-program-kind.ts'

export const [
  CreditUnits,
  CreditUnitSchema,
  CreditUnitEnum,
  unbrandCreditUnit,
] = CreateBrandedEnum(
  { brand: 'CreditUnit' },
  'mntn_credits',
  'meta',
  'tiktok',
  'linkedin'
)

export type CreditUnit = ZodInfer<typeof CreditUnitSchema>

export function isCreditUnit(value: unknown): value is CreditUnit {
  return CreditUnitSchema.safeParse(value).success
}

export function toCreditUnit(value: PartnerProgramKind): CreditUnit {
  return CreditUnitSchema.parse(value)
}

export function toPartnerProgramKind(value: CreditUnit): PartnerProgramKind {
  return PartnerProgramKindSchema.parse(value)
}
